import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from 'src/metronic/views/partials/partials.module';
import { AccordionsGroupModule } from '../shared/components/accordions-group/accordions-group.module';
import { AlertFramedModule } from '../shared/components/alert-framed/alert-framed.module';
import { AlertModule } from '../shared/components/alert/alert.module';
import { FramedPortletModule } from '../shared/components/framed-portlet/framed-portlet.module';
import { IconCardModule } from '../shared/components/icon-card/icon-card.module';
import { InfoBoxModule } from '../shared/components/info-box/info-box.module';
import { SpinnerModule } from '../shared/components/spinner/spinner.module';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { HeaderCardComponent } from './home-page/header-card/header-card.component';
import { HomePageComponent } from './home-page/home-page.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';


@NgModule({
  declarations: [
    HomeComponent,
    ContactPageComponent,
    HomePageComponent,
    HeaderCardComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    TranslateModule,
    PartialsModule,
    AlertModule,
    AlertFramedModule,
    IconCardModule,
    InfoBoxModule,
    AccordionsGroupModule,
    FramedPortletModule,
    SpinnerModule
  ]
})
export class HomeModule { }
